// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.articleTemplates', {
    url: '/articletemplates',
    templateUrl:
      'main/configuration/articleTemplates/articleTemplates.tpl.html',
    data: { pageTitle: 'Article templates' },
  });
};

angular.module('configuration.articleTemplates', []).config(config);
